import { useLingui } from '@lingui/react/macro';
import { type FC, memo } from 'react';
import { useParams } from 'wouter';
import { Breadcrumb } from '@/base/Breadcrumb';
import { SEO_ORIGIN } from '@/base/constants';
import { useSettings } from '@/settings/api';
import { useCoin } from '@/shared/api';

type CoinBreadcrumbProps = {
  slug?: string;
  type: 'buy' | 'price';
};

export const CoinBreadcrumb: FC<CoinBreadcrumbProps> = memo(
  ({ slug, type }) => {
    const { t } = useLingui();
    const [{ language }] = useSettings();
    const { slug: rawSlug } = useParams<{ slug: string }>();
    const normalizedSlug = slug?.toUpperCase();
    const { data: coin } = useCoin(normalizedSlug);

    const displaySymbol =
      (language === 'en' ? coin?.name : coin?.iraqi_name) ??
      normalizedSlug ??
      'Asset';
    const section = type === 'buy' ? 'buy-and-sell' : 'price';
    const sectionLabel = type === 'buy' ? t`Buy & Sell` : t`Prices`;
    const home = `${SEO_ORIGIN}/${language}`;

    return (
      <Breadcrumb
        items={[
          { name: t`Home`, url: home },
          { name: sectionLabel, url: `${home}/${section}` },
          { name: displaySymbol, url: `${home}/${section}/${rawSlug}` },
        ]}
        className="desktop:mb-12 mb-6"
      />
    );
  },
);
